// extracted by mini-css-extract-plugin
export default {"root":"menuItems_root__8Y-R1"};